import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4db8e05f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "header__wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "header__shopping-cart" }
const _hoisted_7 = {
  key: 0,
  class: "header__order-bubble label-small"
}
const _hoisted_8 = {
  key: 0,
  class: "header__menu"
}
const _hoisted_9 = { class: "content__inner" }
const _hoisted_10 = { class: "content__footer" }
const _hoisted_11 = {
  href: "https://touringery.ee/",
  target: "_blank",
  class: "header__logo-link"
}
const _hoisted_12 = { class: "content__footer-right" }
const _hoisted_13 = {
  class: "content__footer-link content__footer-text",
  href: "https://touringery.ee/",
  target: "_blank"
}
const _hoisted_14 = { class: "content__footer-terms" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "content__footer-text" }, "© 2024 Touringery OÜ", -1))

import TouringeryLogo from '@/components/TouringeryLogo.vue'
import SelectLanguage from '@/components/SelectLanguage.vue'
import BaseIcon from '@/components/BaseIcon.vue'
import BaseButton from '@/components/BaseButton.vue'
import { FORMATS } from '@/enums/components'
import { useRouter } from 'vue-router'
import { ROUTE_PATHS } from '@/router/public/paths'
import { useBreakpoints } from '@/composables/useBreakpoints'
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useOrderStore } from '@/store/order'
import ERFLogo from '@/components/ERFLogo.vue'
import { useThemeStore } from '@/store/theme'


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicLayout',
  setup(__props) {

const router = useRouter()
const { isMobile } = useBreakpoints()
const mobileSidebarCollapsed = ref(true)

const orderStore = useOrderStore()
const { order } = storeToRefs(orderStore)
const themeStore = useThemeStore()

const goToCart = () => {
  if (!order.value.uuid) {
    return
  }
  router.push({
    name: ROUTE_PATHS.CART,
    params: { uuid: order.value.uuid },
  })
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(themeStore).getLogoSrc)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(themeStore).getLogoSrc,
                height: "52",
                class: "header__logo"
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createBlock(TouringeryLogo, {
                key: 1,
                width: 121,
                height: 24,
                icon: 'logo-provider',
                class: "header__logo"
              })),
          _createVNode(ERFLogo, { style: {"max-height":"60px","width":"min-content"} }),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(BaseIcon, {
              class: _normalizeClass({
                'header__shopping-cart-empty': !_unref(orderStore).items.length,
              }),
              icon: "shopping-cart-simple",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => goToCart(), ["prevent"]))
            }, null, 8, ["class"]),
            (_unref(orderStore).orderUuid)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(isMobile) ? '' : _unref(orderStore).items.length), 1))
              : _createCommentVNode("", true)
          ]),
          (_unref(isMobile) && mobileSidebarCollapsed.value)
            ? (_openBlock(), _createBlock(BaseButton, {
                key: 2,
                format: _unref(FORMATS).TERTIARY,
                class: "header__mobile-menu-button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (mobileSidebarCollapsed.value = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(BaseIcon, {
                    icon: "menu",
                    size: 32
                  })
                ]),
                _: 1
              }, 8, ["format"]))
            : _createCommentVNode("", true),
          (_unref(isMobile) && !mobileSidebarCollapsed.value)
            ? (_openBlock(), _createBlock(BaseButton, {
                key: 3,
                format: _unref(FORMATS).TERTIARY,
                class: "header__mobile-menu-button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (mobileSidebarCollapsed.value = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(BaseIcon, {
                    icon: "X",
                    size: 32
                  })
                ]),
                _: 1
              }, 8, ["format"]))
            : (!_unref(isMobile))
              ? (_openBlock(), _createBlock(SelectLanguage, { key: 4 }))
              : _createCommentVNode("", true)
        ])
      ]),
      (_unref(isMobile) && !mobileSidebarCollapsed.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(SelectLanguage)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("footer", _hoisted_10, [
        _createElementVNode("a", _hoisted_11, [
          _createVNode(TouringeryLogo, {
            class: "content__footer-logo",
            icon: 'logo-provider',
            width: 102,
            height: 20
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.$t('contactUs')), 1),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_router_link, {
              class: "content__footer-link content__footer-text",
              to: { name: _unref(ROUTE_PATHS).TERMS }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('termsOfService')), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              class: "content__footer-link content__footer-text",
              to: { name: _unref(ROUTE_PATHS).PRIVACY_POLICY }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('privacyPolicy')), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _hoisted_15
        ])
      ])
    ])
  ]))
}
}

})